export default __webpack_public_path__ + "static/media/S_Forms.257c47eb.png";